<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-customer-overview-panel-journey-and-response-feedback" v-loading="loading" element-loading-text="Loading...">
    <wy-panel-header ref="panelHeader" :panelHeaderData="tabData" :controller="module" :panelTitle="panelTitle" />
    <wy-panel-tabs :controller="module" :topSectionData="tabData"/>
    <div v-loading="loading"  class="table-container">
      <div v-if="(tableData.responseFeedbackPositive && tableData.responseFeedbackPositive.data && tableData.responseFeedbackPositive.data.length>0) || (tableData.responseFeedbackNegative && tableData.responseFeedbackNegative.data && tableData.responseFeedbackNegative.data.length>0)">
        <table v-if="tableData.responseFeedbackPositive && tableData.responseFeedbackPositive.data && tableData.responseFeedbackPositive.data.length>0" class="performance-overview-table" element-loading-text="Loading..." >
          <thead>
            <tr class="table-titles">
              <div class="table-flex-container head-container">
                <td class="index"></td>
                <td class="performance-table-head table-head response-feedback"><b>Top positive responses: total: {{tableData.responseFeedbackPositive.totalSize}}</b></td>
                <td ref="positiveVolume" class="performance-table-head table-head volume sortable sorted descending" @click="sortingColumn($event, 'positive', 'volume')"><b>volume</b></td>
                <td ref="positivePercentage" class="performance-table-head table-head total-volume total-valume-header sortable" @click="sortingColumn($event, 'positive', 'percentage')"><b>% of total</b></td>
              </div>
            </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in tableData.responseFeedbackPositive.data" :key="index">
            <div class="table-flex-container">
              <td class="index">{{(paginationPositive.pageNo-1)*4 + index + 1}}</td>
              <td :title="item.name" class="response-feedback">
                <!-- <span class="index">{{index + 1}}</span> -->
                <span class="feedback-name">{{item.name}}</span></td>
              
              <td class="volume">{{item.volume.toLocaleString('en-US')}}</td>
              <td class="total-volume">
                <div class="flex-stats">
                  <span class="percentage">{{Number(item.percentage).toFixed(2)}}%</span>
                </div>
              </td>
            </div>
          </tr>
          </tbody>
          <div class="div-pagination positive"> 
            <span>Showing {{(paginationPositive.pageNo-1)*4 + 1}} to {{((paginationPositive.pageNo)*4>tableData.responseFeedbackPositive.totalSize)?tableData.responseFeedbackPositive.totalSize:paginationPositive.pageNo*4}} of {{tableData.responseFeedbackPositive.totalSize}} positive responses</span>
            <el-pagination
              :page-size="paginationPositive.pageSize"
              :page-count="paginationPositive.pageCount"
              :current-page="paginationPositive.pageNo"
              @current-change="pageChanged($event, 'positive', paginationPositive)"
              layout="prev, next">
            </el-pagination>
          </div>
        </table>
        <div v-else class="no-data-flex positive in-talbe"> 
          <img class="no-data-image" src="../../../assets/icons/icon_performance_no_data.svg" alt="no data icon">
          <span class="no-data-text">Sorry!</span>
          <span class="no-data-text-small">No data available for positive responses.</span>
        </div>
        
        <table v-if="tableData.responseFeedbackNegative && tableData.responseFeedbackNegative.data && tableData.responseFeedbackNegative.data.length>0" class="performance-overview-table" element-loading-text="Loading..." >
          <thead>
            <tr class="table-titles">
              <div class="table-flex-container head-container">
                <td class="index"></td>
                <td class="performance-table-head table-head response-feedback"><b>Top negative responses: total: {{tableData.responseFeedbackNegative.totalSize}}</b></td>
                <td ref="negativeVolume" class="performance-table-head table-head volume sortable sorted descending"  @click="sortingColumn($event, 'negative', 'volume')"><b>volume</b></td>
                <td ref="negativePercentage" class="performance-table-head table-head total-volume total-valume-header sortable" @click="sortingColumn($event, 'negative', 'percentage')"><b>% of total</b></td>
              </div>
            </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in tableData.responseFeedbackNegative.data" :key="index">
            <div class="table-flex-container">
              <td class="index">{{(paginationNegative.pageNo-1)*4 + index + 1}}</td>
              <td :title="item.name" class="response-feedback">
                <!-- <span class="index">{{index + 1}}</span> -->
                <span class="feedback-name">{{item.name}}</span></td>
              <td class="volume">{{item.volume.toLocaleString('en-US')}}</td>
              <td class="total-volume">
                <div class="flex-stats">
                  <span class="percentage">{{Number(item.percentage).toFixed(2)}}%</span>
                </div>
              </td>
            </div>
          </tr>
          </tbody>
          <div class="div-pagination"> 
            <span>Showing {{(paginationNegative.pageNo-1)*4 + 1}} to {{((paginationNegative.pageNo)*4>tableData.responseFeedbackNegative.totalSize)?tableData.responseFeedbackNegative.totalSize:paginationNegative.pageNo*4}} of {{tableData.responseFeedbackNegative.totalSize}} negative responses</span>
            <el-pagination
              :page-size="paginationNegative.pageSize"
              :page-count="paginationNegative.pageCount"
              :current-page="paginationNegative.pageNo"
              @current-change="pageChanged($event, 'negative', paginationNegative)"
              layout="prev, next">
            </el-pagination>
          </div>
        </table>
        <div v-else class="no-data-flex in-talbe"> 
          <img class="no-data-image" src="../../../assets/icons/icon_performance_no_data.svg" alt="no data icon">
          <span class="no-data-text">Sorry!</span>
          <span class="no-data-text-small">No data available for negative responses.</span>
        </div>
      </div>
      
      <div v-else class="no-data-flex"> 
        <img class="no-data-image" src="../../../assets/icons/icon_performance_no_data.svg" alt="no data icon">
        <span class="no-data-text">Sorry!</span>
        <span class="no-data-text-small">No data available yet.</span>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { mapGetters, mapActions } from 'vuex';
  // import WyUtils from '../../../library/wy-utils.js';
  import WyCustomerUtils from '../utils/wy-customer-utils.js';
  import WyPanelHeader from '../../panel-views/wy-panel-header.vue';
  import WyPanelTabs from '../../panel-views/wy-panel-tabs.vue';

  export default Vue.extend({
    name: 'wy-customer-overview-panel-journey-and-response-feedback',
    props: ["controller"],
    components: { 
      'wy-panel-header': WyPanelHeader,
      'wy-panel-tabs': WyPanelTabs,
    },

    data() {
      return {
        module: this,
        loading: false,
        templateData: {},
        rawData: {},
        pannelData: {},
        tabData: {data:[]},
        tableData: {},
        // lineChartData: {},
        panelId: 'responseFeedback',
        panelTitle: 'Response Feedback',
        // legendData: {},
        dataIndex: 0,
        dateRange: 'month',
        paginationNegative: {
          pageSize: 4,
          pageCount: 10,
          pageNo: 1,
          sortOrder: 'descending',
          sortBy: 'volume'
        },
        paginationPositive: {
          pageSize: 4,
          pageCount: 10,
          pageNo: 1,
          sortOrder: 'descending',
          sortBy: 'volume'
        },
      }
    },

    computed: {
      ...mapGetters(['dataModel', 'companyConfig']),
    },

    methods: {
      ...mapActions(['fetchJourneyAndResponseFeedback', 'prepareCustomerBehaviourViewByData']),

      async changeDateRange(dateRange) {
        this.dateRange = dateRange;
        this.controller.changeDateRange(dateRange, this.rawData, this.templateData, this);
      },

      mouseover() {
        this.$refs.panelHeader.$refs.settingSection.$el.classList.add("show");
      },
      mouseout(e) {
        if(e.toElement && (e.toElement._prevClass == "components-container" || e.toElement._prevClass == 'wy-performance-overview-page' || e.toElement._prevClass == 'el-main wy-container-main')) {
          this.$refs.panelHeader.$refs.settingSection.$refs.configureDropdown.hide();
        }
        this.$refs.panelHeader.$refs.settingSection.$el.classList.remove("show");
      },

      async sortingColumn(e, feedbackType, sortBy) {
        let pageSetting = {};
        if(feedbackType == 'positive') {
          pageSetting = this.paginationPositive;
        }
        else {
          pageSetting = this.paginationNegative;
        }
        pageSetting.sortOrder = (pageSetting.sortOrder == 'ascending') ? 'descending' : 'ascending';
        pageSetting.sortBy = sortBy;
        pageSetting.pageNo = 1;
        let options = {
          pageSize: pageSetting.pageSize,
          sortOrder: pageSetting.sortOrder,
          sortBy: sortBy,
          feedbackType: feedbackType,
          pageNo: pageSetting.pageNo
        }
        // console.log(e.target, feedbackType)
        this.rawData = await this.fetchJourneyAndResponseFeedback(options);
        if(this.rawData) {
          if(feedbackType == 'positive') {
            this.tableData.responseFeedbackPositive.data = this.rawData.responseFeedback.responseFeedbackPositive.data;
          }
          if(feedbackType == 'negative') {
            this.tableData.responseFeedbackNegative.data = this.rawData.responseFeedback.responseFeedbackNegative.data;
          }
        }
        if(feedbackType == 'positive') {
          this.$refs.positiveVolume.classList.add("disabled")
          this.$refs.positivePercentage.classList.add("disabled")

          this.$refs.positiveVolume.classList.remove("sorted")
          this.$refs.positivePercentage.classList.remove("sorted")

          this.$refs.positiveVolume.classList.remove("ascending")
          this.$refs.positivePercentage.classList.remove("ascending")

          this.$refs.positiveVolume.classList.remove("descending")
          this.$refs.positivePercentage.classList.remove("descending")
        }
        if(feedbackType == 'negative') {
          this.$refs.negativeVolume.classList.add("disabled")
          this.$refs.negativePercentage.classList.add("disabled")

          this.$refs.negativeVolume.classList.remove("sorted")
          this.$refs.negativePercentage.classList.remove("sorted")

          this.$refs.negativeVolume.classList.remove("ascending")
          this.$refs.negativePercentage.classList.remove("ascending")

          this.$refs.negativeVolume.classList.remove("descending")
          this.$refs.negativePercentage.classList.remove("descending")
        }
        
        if(pageSetting.sortOrder == 'ascending') {
          e.target.classList.add("sorted")
          e.target.classList.add("ascending")
        }
        else {
          e.target.classList.add("sorted")
          e.target.classList.add("descending")
        }
      },

      async pageChanged(pageNo, feedbackType, pageSetting) {
        // console.log(this.pageSize, feedbackType, pageNo);
        pageSetting.pageNo = pageNo;
        let options = {
          pageSize: pageSetting.pageSize,
          sortOrder: pageSetting.sortOrder,
          sortBy: pageSetting.sortBy,
          feedbackType: feedbackType,
          pageNo: pageSetting.pageNo
        }

        this.rawData = await this.fetchJourneyAndResponseFeedback(options);
        if(this.rawData) {
          if(feedbackType == 'positive') {
            this.tableData.responseFeedbackPositive.data = this.rawData.responseFeedback.responseFeedbackPositive.data;
          }
          if(feedbackType == 'negative') {
            this.tableData.responseFeedbackNegative.data = this.rawData.responseFeedback.responseFeedbackNegative.data;
          }
        }
      },     

      async handleFilterChange() {
        // this.overviewData = null
        if((!this.loading && this.dataModel.dateEnd) ||this.dataModel.dateEnd) {
          this.loading = true;
          this.rawData = await this.fetchJourneyAndResponseFeedback();
          if(this.rawData && Object.keys(this.rawData).length > 0 && this.$refs.panelHeader && this.rawData.responseFeedback) {
            this.templateData = WyCustomerUtils.getCustomerBehaviourJourneyAndResponseFeedbackData();
            this.dateRange = this.controller.setDefaultDateRange();
            this.$refs.panelHeader.$refs.settingSection.selectedDateRange = this.dateRange;
            this.pannelData = await this.prepareCustomerBehaviourViewByData({viewBy: this.dateRange, rawData: this.rawData, templateData: this.templateData, companyConfig: this.companyConfig})
            
            let data = {
              selected: true,
              suffix: '%',
              suffixKey: "ResponseFeedback",
              displayValue: this.pannelData.responseFeedback.responseFeedback,
              key: "responseFeedback",
              label: "Response feedback",
              trendGraph: this.pannelData.responseFeedback.responseFeedbackTrendGraph,
              value: this.pannelData.responseFeedback.responseFeedback
            }
            this.tableData.responseFeedbackPositive = this.pannelData.responseFeedback.responseFeedbackPositive;
            this.tableData.responseFeedbackNegative = this.pannelData.responseFeedback.responseFeedbackNegative;
            
            if(this.tableData.responseFeedbackPositive.data.length == 0 && this.tableData.responseFeedbackNegative.data.length == 0) {
              data.displayValue = 'N/A';
              data.value = 'N/A';
            }
            // this.tableData.responseFeedbackPositive.data = []
            // this.tableData.responseFeedbackNegative.data = []
            this.paginationNegative = {
              pageSize: 4,
              pageCount: 10,
              pageNo: 1,
              sortOrder: 'descending',
              sortBy: 'volume'
            }
            this.paginationPositive = {
              pageSize: 4,
              pageCount: 10,
              pageNo: 1,
              sortOrder: 'descending',
              sortBy: 'volume'
            }
            if(this.$refs.positiveVolume && this.$refs.positivePercentage) {
              this.$refs.positiveVolume.classList.add("disabled")
              this.$refs.positivePercentage.classList.add("disabled")

              this.$refs.positiveVolume.classList.remove("sorted")
              this.$refs.positivePercentage.classList.remove("sorted")

              this.$refs.positiveVolume.classList.remove("ascending")
              this.$refs.positivePercentage.classList.remove("ascending")

              this.$refs.positiveVolume.classList.remove("descending")
              this.$refs.positivePercentage.classList.remove("descending")

              this.$refs.positiveVolume.classList.add("sorted")
              this.$refs.positiveVolume.classList.add("descending")
            }

            if(this.$refs.negativeVolume && this.$refs.negativePercentage) {
              this.$refs.negativeVolume.classList.add("disabled")
              this.$refs.negativePercentage.classList.add("disabled")

              this.$refs.negativeVolume.classList.remove("sorted")
              this.$refs.negativePercentage.classList.remove("sorted")

              this.$refs.negativeVolume.classList.remove("ascending")
              this.$refs.negativePercentage.classList.remove("ascending")

              this.$refs.negativeVolume.classList.remove("descending")
              this.$refs.negativePercentage.classList.remove("descending")

              this.$refs.negativeVolume.classList.add("sorted")
              this.$refs.negativeVolume.classList.add("descending")
            }
            this.paginationPositive.pageCount = Math.ceil(this.pannelData.responseFeedback.responseFeedbackPositive.totalSize/this.paginationPositive.pageSize);
            this.paginationNegative.pageCount = Math.ceil(this.pannelData.responseFeedback.responseFeedbackNegative.totalSize/this.paginationPositive.pageSize);
            this.tabData.data = [];
            this.tabData.tooltips = "Displays your top responses with positive and negative </br>feedback and the ability to sort by feedback volume or  </br>the percent of total that is either positive or negative"
            this.tabData.data.push(data);
            this.loading = false;
          }
          else {
            this.loading = false;
            this.pannelData = {};
            this.sectionData = {};
          }
        }
      },
    },

    async created(){
      this.dateRange = this.controller.setDefaultDateRange();
      await this.handleFilterChange();
      // this.$el.classList.add("full-size");
    }
  });
</script>

<style lang="scss">
  .wy-customer-overview-panel-journey-and-response-feedback {
  // .bottom-flex-title {
  //   font-size: 0.72vw !important;
  // }
  // .change-over-time-component {
  //   position: relative;
  //   top: -45px;
  // }
    .VueCarousel.overview-table .VueCarousel-slide:hover {
      background-color: transparent !important;
    }
    .tab-section:hover{
      background-color: transparent !important;
      // pointer-events: none;
    }
    .VueCarousel.overview-table {
      .VueCarousel-slide.selected {
        border-bottom: 0.2vw transparent solid;
      }
    }
    .second-table{
        border-bottom: none !important;
        border-top: none !important;
        border-left: none !important;
    }
    .pie-left-column-right {
        // min-height: calc(100% - 20px);
        padding-right: 0px;
        margin-bottom: 10px;
        border-top: none !important;
        border: 1px solid #cad2da;
        width: 100% !important;
        height: 263px !important;
        overflow: hidden;
        border-radius: 0px !important;
        /* height: 160px !important; */
        margin-top: 0px !important;
        // border-bottom: 0px !important;
        margin-right: 0px !important;
        border-left: none !important;
    }
    table.customer-overview-table {
        width: 100%;
    }

    .performance-overview-table {
      width: 100%;
      height: 100%;
      border-collapse: collapse;
      font-size: 14.22px;

      .table-flex-container{
        display: flex;
        justify-content: space-between;
      }
      .performance-table-head{
        font-family: Helvetica Neue, Arial, Helvetica, sans-serif !important;
        font-size: 14.5px !important;
        font-weight: 400 !important;
        color: var(--site-font-secondary-color) !important;
        margin-right: 0px;
      }
      .head-container{
        // border-bottom: 1px solid #CAD2DA;
        white-space: nowrap;
        width: 100%;
      }
      .total-valume-header {
        margin-right: 0px;
      }
      .percentage {
        position: relative;
        // left: 0.5vw;
        // width: 40px;
        text-align: center;
      }

      .feedback-name {
        // width: 22.34vw !important;
        // max-width: 305px;
        max-width: 70%;
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        /* margin-right: -18px; */
        text-overflow: ellipsis;
        position: relative;
      }

      thead {
        display: table;
        width: calc(100% - 0px);
        color: #000000;
        font-size: 14.5px;
        font-family: Helvetica Neue, Helvetica;
        font-weight: 500;
        td {
          pointer-events: none;
        }
        td.sortable::after {  // this reserves space for the up-arrow/down-arrow icon (not shown yet)
          content: "";
          display: inline-block;
          height: 15px;
          background-image: url('../../../assets/icons/icon_response_perf_sort_disabled.svg');
          width: 15px;
          position: relative;
          top: 4px;
          left: 7px;
          background-repeat: no-repeat;
          cursor: pointer;
          pointer-events: all;
        }
        td.sortable.disabled::after {
          background-image: url('../../../assets/icons/icon_response_perf_sort_disabled.svg');
        }
        td.sortable.sorted.ascending::after {
          background-image: url('../../../assets/icons/icon_response_perf_sort_ascend.svg');
        }
        td.sortable.sorted.descending::after {
          background-image: url('../../../assets/icons/icon_response_perf_sort_descend.svg');
        }
        td.sortable.sorted.ascending:hover::after {
          background-image: url('../../../assets/icons/icon_response_perf_sort_ascend.svg');
        }
        td.sortable.sorted.descending:hover::after {
          background-image: url('../../../assets/icons/icon_response_perf_sort_descend.svg');
        }
        td.sortable:hover {
          // background-color: #E1E6EC;
          // cursor: pointer;
          // color: #214586;
          // .sort-caret.ascending {
          //   background-image: url('../../../assets/icons/icon_response_perf_sort_ascend.svg');
          // }
          // .sort-caret.descending {
          //   background-image: url('../../../assets/icons/icon_response_perf_sort_descend.svg');
          // }
        }
        td.sortable:not(.sorted):hover::after {
          // background-image: url('../../../assets/icons/icon_response_perf_sort_descend.svg');
        }
        td:not(.sortable) {
          span {
            padding-left: 0;
          }
        }
      }
      tbody {
        display: inline-block; /* to enable vertical scrolling */
        // max-height: 561px; 
        height: 176px;
        // overflow-y: scroll; /* keeps the scrollbar even if it doesn't need it; display purpose */
        width: calc(100%);
        padding-left: 0px;
        background-color: #FFF;
      }
      progress {
        display: block;
        width: 100%;
        padding: 0px 0 0 0;
        margin: 0;
        background: none;
        border: 0;
        border-radius:5 0px;
        text-align: left;
        position: relative;
        font-family: "Helvetica Neue", Helvetica;
        font-size: 15px;
      }
      progress.percentage-bar::-webkit-progress-value {
        background: #4D50E8 !important;
      }
      progress::-webkit-progress-bar {
        height: 12px;
        width: 80%;
        margin: 0 auto;
        background-color: #CAD2DA;
        border-radius: 100px; 
        position: relative;
        top:2px;
      }
      progress::-webkit-progress-value {
        display: inline-block;
        height: 11px;
        margin: 0px -10px 2px 0;
        // padding-left: 50px; /* Rounded corners requires a padding */
        border-radius: 50px 0 0 50px;
      }

      .response-feedback{
        padding-left:10px;
        padding-right: 0px;
        font-family: Helvetica Neue, arial;
        color: var(--site-font-tertiary-color);
        font-size: 14.22px;
      }
      .index{
        // width: 0vw;
        // right: 31px;
        left: 20px;
        padding-right: 20px;
        width: 5%;
        position: relative;
        font-family: Helvetica Neue, arial;
        color: var(--site-font-tertiary-color);
        font-size: 14.22px;
        padding-left: 0vw;
        font-weight: 500;
      }
      .table-head.response-feedback {
        position: relative;
        // left: 7px;
      }
      .volume {
        // width: 4.24vw;
        position: relative;
        font-family: Helvetica Neue, arial;
        color: var(--site-font-tertiary-color);
        font-size: 14.22px;
        // right: 7.5vw;
        text-align: center;
        width: 15%;
      }
      tbody .volume {
        right: 2px;
      }
      
      .total-volume{
        width: 30%;
        position: relative;
        // right: 10.23vw;
        padding-right: 0vw;
        font-family: Helvetica Neue, arial;
        color: var(--site-font-tertiary-color);
        font-size: 14.22px;
      }
      .flex-stats{
        display: flex;
        justify-content: space-around; 
        align-items: center;
        // width: 11.7vw !important;
      }

      // td {
      //   padding: 19px 15px;
      // }

      .table-titles{
        .total-volume{
          position: relative !important;
          text-align: center;
          // right: 7vw;
        }
      }

      tr {
        display: table; /* display purpose; th's border */
        width: 100%;
        box-sizing: border-box; /* because of the border (Chrome needs this line, but not FF) */
        border-bottom: 1px solid #CAD2DA;
      }

      td {
        text-align: left;
        color: #000000;
        border-bottom: none;
        border-left: none;
        // width: 19px !important;
        font-size: 14.22px;
        font-family: Helvetica Neue, Helvetica;
        font-weight: 400;
        padding: 13px 0px;
        // border-bottom: 1px solid #CAD2DA;
      }
      .warning-row{
        color:black;
      }
      td.response-feedback {
        // width: 13.34vw !important;
        // max-width: 267px;
        width: 50%;
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        margin-right: 0px;
        text-overflow: ellipsis;
        position: relative;
        left: 0px;
        display: flex;
      }
      .change-overtime-info{
        display: flex;
        flex-direction: column;
        margin-left: 0.3vw;
      }
      .top-flex{
        background-color: #FFF;
      }
      .el-table .cell {
        font-size: 14.22px;
        color: var(--site-font-chart-color);
        font-weight: normal;
        position: relative;
        left: 0.35vw;
      }

      .icon-info{
        display: inline-block;
        background: url('../../../assets/icons/icon_info_performance_overview.svg') no-repeat;
        width: 20px;
        height: 17px;
        position: relative;
        top: 8px;
        margin-left: 0.25vw;
      }
      #line-chart{
        position: relative;
        right: 1vw;
        width: 22.59vw;
        bottom: 2vw;
      }
      .move-info{
        width: 0.9vw;
        height: 19px;
        margin-left: 5px;
        position: relative;
        top: 4px;
      }
      .div-pagination.positive {
        border-bottom: 1px solid #CAD2DA;
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
      }
      .div-pagination {
        display: flex;
        background-color: #F5F8FA;
        padding: 6px 0px 5px 0px;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        // border-bottom: 1px solid #CAD2DA;
        span {
          text-align: center;
          width: 100%;
          line-height: 2;
          margin-left: 86px;
          color: #828E9A;
          font-weight: 400;
        }
        .el-pagination {
          position: relative;
          top: 2px;
          margin-left: auto;
        }
      }
      .el-pagination .btn-prev,.btn-next {
        padding-right: 12px;
        // color: #C0C4CC;
        background-color: #FFF;
        cursor: pointer;
        border: 1px solid #CAD2DA;
        padding-right: 0px;
        padding-left: 0px;
        min-width: 20px;
        height: 20px;
        line-height: 20px;
        margin-right: 10px;
      }
      .el-pagination button:disabled {
        color: #C0C4CC;
        cursor: not-allowed;
      }
      .el-pagination button:hover {
        color: #303133;
      }
      .el-pagination button:disabled:hover {
        color: #C0C4CC;
      }
    }
    .table-container {
      .no-data-flex.positive.in-talbe {
        border-bottom: 1px solid #CAD2DA
      }
      .no-data-flex.in-talbe {
        min-height: 260px !important;
        padding-top: 0px;
        .no-data-image {
          // width: 13%;
          // margin-left: 43.5%;
          min-height: 125px;
          margin-top: 2% !important;
        }
      }
      .no-data-flex {
        padding-top: 105px;
      }
    }
  }
</style>